import { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import authApi from '../../api/auth';
import { FEEDBACK_ICON, LOGOUT_ICON, PERSON_ICON, RECEIPT_ICON, SETTINGS_ICON } from '../../assets/icons';
import { useAppDispatch } from '../../hooks';
import { login } from '../../reducers/authSlice';
import { setUserProfile } from '../../reducers/userSlice';
export default function Account() {
  const menuOptions = [
    {
      title: 'Profile',
      icon: PERSON_ICON,
      path: '/account'
    },
    {
      title: 'Transactions and Receipts',
      path: '/account/transactions',
      icon: RECEIPT_ICON
    },
    {
      title: 'Settings',
      path: '/account/settings',
      icon: SETTINGS_ICON
    },
    {
      title: 'Share feedback',
      path: '/account/feedback',
      icon: FEEDBACK_ICON
    }
  ];
  const dispatch = useAppDispatch();

  const logout = async () => {
    await authApi.logout().catch((err) => err);
    dispatch(login(null));
    dispatch(setUserProfile(null));
  };

  return (
    <div className="w-full min-h-screen flex flex-col">
      <div className="w-full md:flex grow">
        <div className="w-3/12 sticky top-0 h-screen bg-neutralBlue2 md:flex hidden flex-col gap-7 px-10 pt-16 pb-4">
          {menuOptions.map((item, index) => (
            <Menu item={item} key={index} />
          ))}

          <div className="mt-auto flex items-center gap-4 cursor-pointer" onClick={() => logout()}>
            <img src={LOGOUT_ICON} alt="Logout icon" className="w-4" />
            <p className="text-secondary text-sm font-medium">Logout</p>
          </div>
        </div>

        <div className="w-full lg:px-7 px-4 bg-white">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

function Menu({
  item
}: {
  item: {
    title: string;
    path: string;
    icon: string;
  };
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative w-full flex flex-col gap-4">
      <Link to={item.path}>
        <div onClick={() => setOpen(!open)} className="w-full flex gap-2 items-center cursor-pointer">
          <img src={item.icon} alt="" className="w-3" />
          <h1 className="text-sm text-primary font-medium">{item.title}</h1>
        </div>
      </Link>
    </div>
  );
}
